import { render, staticRenderFns } from "./_DnsLabel.vue?vue&type=template&id=cad57de2"
import script from "./_DnsLabel.vue?vue&type=script&lang=ts"
export * from "./_DnsLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports